import weather01d from '@images/icon-weather-01d.svg';
import weather02d from '@images/icon-weather-02d.svg';
import weather03d from '@images/icon-weather-03d.svg';
import weather04d from '@images/icon-weather-04d.svg';
import weather09d from '@images/icon-weather-09d.svg';
import weather10d from '@images/icon-weather-10d.svg';
import weather11d from '@images/icon-weather-11d.svg';
import weather13d from '@images/icon-weather-13d.svg';
import weather50d from '@images/icon-weather-50d.svg';
import weather01n from '@images/icon-weather-01n.svg';
import weather02n from '@images/icon-weather-02n.svg';
import weather10n from '@images/icon-weather-10n.svg';

import cloud from '@images/weather/cloud.svg';
import cloudy from '@images/weather/cloudy.svg';
import cloudynight from '@images/weather/cloud.svg';
import night from '@images/weather/night.svg';
import rain from '@images/weather/rain.svg';
import snow from '@images/weather/snow.svg';
import sun from '@images/weather/sun.svg';
import downpour from '@images/weather/downpoor.svg';
import nightrain from '@images/weather/nightrain.svg';
import snowsun from '@images/weather/snowsun.svg';
import sunrain from '@images/weather/sunrain.svg';
import thunder from '@images/weather/thunder.svg';
import thunderstormrain from '@images/weather/thunderrain.svg';
import nodata from '@images/weather/nodata.svg';


export const weatherIcons = {
	cloud,
	cloudy,
	cloudynight,
	night,
	rain,
	snow,
	sun,
	downpour,
	nightrain,
	snowsun,
	sunrain,
	thunder,
	thunderstormrain,
	nodata
}


const mapWeatherIconByName: any = {
    '01d': weather01d,
	'02d': weather02d,
	'03d': weather03d,
	'04d': weather04d,
	'09d': weather09d,
    '10d': weather10d,
	'11d': weather11d,
    '13d': weather13d,
	'50d': weather50d,
    '01n': weather01n,
	'02n': weather02n,
    '10n': weather10n,
}

export default mapWeatherIconByName